// @givmo/app-admin — the way back in for someone whose company locks how they sign in (AS-WEB26):
// `/lost-company-access`, the address the sign-in chooser's "Lost access to your company sign-in?"
// link opens, and a lock email can name.
//
// The flow is `@givmo/passkeys`' `EscapeHatchFlow`, in this portal's own card (frame C1). "Back to
// sign in" returns to the door that opened it: the `back` the link carried (sanitized, a same-origin
// path), else the chooser.

import { useNavigate, useSearch } from '@tanstack/react-router';
import { EscapeHatchFlow } from '@givmo/passkeys';
import { sanitizeRedirectTarget } from '@givmo/org-console';
import { AuthShell } from './auth-shell';
import { AUTH_ROUTES } from './auth-routing';

/** This portal's door heading, so the flow reads as that door's next screen. */
const HEADING = 'font-sans text-s22 font-w700 tracking-givmo text-text-strong';

export function LostCompanyAccessScreen() {
  const navigate = useNavigate();
  const { back } = useSearch({ strict: false }) as { back?: string };
  const door = sanitizeRedirectTarget(back) ?? AUTH_ROUTES.loginHome;
  return (
    <AuthShell testId="page-lost-company-access">
      <EscapeHatchFlow headingClass={HEADING} onBackToSignIn={() => void navigate({ to: door })} />
    </AuthShell>
  );
}
